import { useCallback } from 'react';

export type UsePaginationReturn = {
  pageIndex: number;
  nextDisabled: boolean;
  prevDisabled: boolean;
  handleNextPage: () => void;
  handlePrevPage: () => void;
  handlePageChange: (page: number) => void;
};

export const usePagination = (
  currentPage: number,
  totalPages: number,
  onPageChange?: (page: number) => void,
): UsePaginationReturn => {
  const nextDisabled = currentPage === totalPages;
  const prevDisabled = currentPage === 1;

  const handleNextPage = () => {
    if (nextDisabled) {
      return;
    }
    if (onPageChange) {
      onPageChange(currentPage + 1);
      return;
    }
  };

  const handlePrevPage = () => {
    if (prevDisabled) {
      return;
    }
    if (onPageChange) {
      onPageChange(currentPage - 1);
      return;
    }
  };

  const handlePageChange = useCallback(
    (page: number) => {
      if (onPageChange) {
        onPageChange(page);
        return;
      }
    },
    [onPageChange],
  );

  return {
    pageIndex: currentPage,
    nextDisabled,
    prevDisabled,
    handleNextPage,
    handlePrevPage,
    handlePageChange,
  };
};
